<template>
    <ul class="menu-list" v-if="getAuthenticationStatus">
        <li><span class="user-name">{{ getAuthenticatedUser.name }}</span></li>
        <li>
            <router-link
                    :to="{ name: 'profile' }"
                    class="dropdown-item"
            >Profile</router-link>
        </li>
        <li>
            <router-link
                    :to="{ name: 'update-password' }"
                    class="dropdown-item"
            >Update Password</router-link>
        </li>
        <li>
            <router-link
                    :to="{ name: 'my-orders' }"
                    class="dropdown-item"
            >My Orders</router-link>
        </li>
        <!-- <li>
          <router-link
                  :to="{ name: 'wishlist' }"
                  class="dropdown-item"
                >Wish List</router-link>
        </li> -->
        <li>
            <a
                    @click="logout"
                    v-loading.fullscreen.lock="loading"
            >Logout</a>
        </li>
    </ul>
    <ul class="menu-list" v-else>
        <li>
        <router-link
                :to="{ name: 'signin' }"
        >Sign in</router-link>
        </li>
        <li>
            <router-link
                    :to="{ name: 'signup' }"
            >Sign Up</router-link>
        </li>
    </ul>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "UserDropDownMobile",
        data() {
            return {
                loading: false
            }
        },
        computed: {
          ...mapGetters('auth', ['getAuthenticationStatus', 'getAuthenticatedUser'])
        },
        methods: {
            async logout() {
                this.loading = true;
                await this.$store.dispatch("auth/sign_out");
                if (!this.getAuthenticationStatus) {
                    await this.$router.push({ name: "home" });
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .menu-list {
        border-bottom:1px dashed #ccc;
        margin-bottom: 1.5rem;
        li {
            display: block!important;
            width: 80%;
        }
        a {
            color: black;
            line-height: 35px;
        }
        li {
            &:last-child {
                a {
                    margin-bottom: 15px;
                }
            }
        }
    }
</style>
